import { vservice } from '@niknevis/vue-modules'
import { AdminPersonRoute } from '@/modules/common/person/routes/admin.person.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

@vservice()
export class AdminPersonService {
  constructor(
    private readonly routes: AdminPersonRoute
  ) {
  }

  getPersons(): Promise<{ [key in PersonTitle]: string }> {
    return HTTP.get(
      this.routes.getPersons()
    ).then(result => result.json())
  }
}